export default "__VITE_ASSET__CqPp9yW8__";